import React from 'react';

import { JIRA_BROWSE_URL } from '../constants';

export function JiraLink({ ticket, style }) {
  if (!ticket) return null;
  return (
    <a
      href={JIRA_BROWSE_URL + ticket}
      target="_blank"
      rel="noreferrer"
      title={`Ouvrir ${ticket} dans Jira`}
      onClick={(e) => e.stopPropagation()}
      style={{ color: '#1D6EA0', textDecoration: 'none', fontFamily: 'monospace', ...style }}
      onMouseEnter={(e) => {
        e.currentTarget.style.textDecoration = 'underline';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.textDecoration = 'none';
      }}
    >
      {ticket}
      <i
        className="ti ti-external-link text-[10px] ml-[3px] [vertical-align:1px]"
        aria-hidden="true"
      />
    </a>
  );
}
